module.exports = __webpack_public_path__ + "static/media/security-lock.d6c54be1.png";